<template>
  <div class="protocol align-center-main">
    <p class="header">用户注册协议</p>
    <Detail></Detail>
    <p class="bottom">
      <el-button size='small' @click='back'>返回注册</el-button>
    </p>
  </div>
</template>

<script>
import Detail from './child/ProtocolDetail';

export default {
  methods: {
    back() {
      this.$router.push('/navigator/auth/regist');
   },
  },
  components: { Detail },  
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.protocol{
  .header{
    line-height: 56px;
  }
  .bottom{
    text-align: center;
    line-height: 100px;
    .el-button{
      background: $color-main;
      border-color: $color-main;
      color: #fff;

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/auth/Protocol.vue